import { FiHome, FiPackage, FiBookOpen, FiTruck, FiBarChart2, FiLogOut, FiClock, FiCoffee } from 'react-icons/fi';

const BottomNav = ({ activeTab, setActiveTab, onLogout }) => {
  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      onLogout();
    }
  };

  const tabs = [
    { name: 'Dashboard', icon: FiHome },
    { name: 'Inventory', icon: FiPackage },
    { name: 'Recipes', icon: FiBookOpen },
    { name: 'Vendors', icon: FiTruck },
    { name: 'Reports', icon: FiBarChart2 },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 dark:bg-gray-800 dark:border-gray-700">
      <div className="flex justify-around">
        <button
          onClick={() => setActiveTab('Dashboard')}
          className={`p-4 flex flex-col items-center ${
            activeTab === 'Dashboard' 
              ? 'text-blue-600 dark:text-blue-400' 
              : 'text-gray-600 dark:text-gray-400'
          }`}
        >
          <FiHome size={20} />
          <span className="text-xs mt-1">Dashboard</span>
        </button>
        <button
          onClick={() => setActiveTab('Inventory')}
          className={`p-4 flex flex-col items-center ${activeTab === 'Inventory' ? 'text-blue-600' : 'text-gray-600'}`}
        >
          <FiPackage size={20} />
          <span className="text-xs mt-1">Inventory</span>
        </button>
        <button
          onClick={() => setActiveTab('Recipes')}
          className={`p-4 flex flex-col items-center ${activeTab === 'Recipes' ? 'text-blue-600' : 'text-gray-600'}`}
        >
          <FiBookOpen size={20} />
          <span className="text-xs mt-1">Recipes</span>
        </button>
        <button
          onClick={() => setActiveTab('BillingAndOrders')}
          className={`p-4 flex flex-col items-center ${activeTab === 'BillingAndOrders' ? 'text-blue-600' : 'text-gray-600'}`}
        >
          <FiTruck size={20} />
          <span className="text-xs mt-1">Billing & Orders</span>
        </button>
        <button
          onClick={() => setActiveTab('Kitchen')}
          className={`p-4 flex flex-col items-center ${activeTab === 'Kitchen' ? 'text-blue-600' : 'text-gray-600'}`}
        >
          <FiCoffee size={20} />
          <span className="text-xs mt-1">Kitchen</span>
        </button>
        <button
          onClick={() => setActiveTab('Reports')}
          className={`p-4 flex flex-col items-center ${activeTab === 'Reports' ? 'text-blue-600' : 'text-gray-600'}`}
        >
          <FiBarChart2 size={20} />
          <span className="text-xs mt-1">Reports</span>
        </button>
        <button
          onClick={handleLogout}
          className="p-4 flex flex-col items-center text-gray-600 dark:text-gray-400 hover:text-red-500 dark:hover:text-red-400"
        >
          <FiLogOut size={20} />
          <span className="text-xs mt-1">Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;